import { find } from "lodash";

import VeryBad from "./icons/VeryBad";
import BadIcon from "./icons/BadIcon";
import NeutralIcon from "./icons/NeutralIcon";
import GoodIcon from "./icons/GoodIcon";
import VeryGood from "./icons/VeryGood";
import UnsetIcon from "./icons/UnsetIcon";
import { isWeb } from "../../../../helpers/utils";
import AppTheme from "../../AppTheme";
import Colors from "./MoodColors";

export const MoodColors = Colors;

const MOODS = [
  {
    Icon: VeryBad,
    value: 1,
    color: MoodColors.VeryBad,
    textColor: AppTheme.containerWhite,
  },
  {
    Icon: BadIcon,
    value: 2,
    color: MoodColors.Bad,
    textColor: AppTheme.almostBlack,
  },
  {
    Icon: NeutralIcon,
    value: 3,
    color: MoodColors.Neutral,
    textColor: AppTheme.almostBlack,
  },
  {
    Icon: GoodIcon,
    value: 4,
    color: MoodColors.Good,
    textColor: AppTheme.almostBlack,
  },
  {
    Icon: VeryGood,
    value: 5,
    color: MoodColors.VeryGood,
    textColor: AppTheme.containerWhite,
  },
];

const UNSET_MOOD = {
  Icon: UnsetIcon,
  value: 3,
  color: MoodColors.Unset,
  textColor: AppTheme.almostBlack,
};

export const getMoods = () => {
  return MOODS;
};

export const getMoodById = (id) => {
  const mood = id && find(MOODS, (m) => m.value == id);
  return mood || UNSET_MOOD;
};

export const getTextColorByMood = (mood = null) => {
  return mood
    ? [1, 5].includes(mood)
      ? AppTheme.containerWhite
      : AppTheme.almostBlack
    : "";
};

export const geReflectionGemStyle = (moodId, hasBorder = false) => {
  const moodModel = getMoodById(moodId);
  const styles = {
    height: 32,
    width: 32,
    borderRadius: 4,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  return hasBorder
    ? {
        ...styles,
        borderWidth: isWeb ? 4 : 2,
        height: 36,
        width: 36,
        borderColor: moodModel.color,
      }
    : {
        ...styles,
        backgroundColor: moodModel.color,
      };
};

export const getGoalProgressColor = (goal = {}) => {
  const { color, mood } = goal;

  return color
    ? color
    : mood == 0
    ? "#F3F2F1"
    : mood > 3
    ? "#23D7C1"
    : mood < 3
    ? "#F34213"
    : "#FFBF00";
};

const MoodsHelper = {
  getMoodById,
  getMoods,
  geReflectionGemStyle,
  getTextColorByMood,
  getGoalProgressColor,
  UNSET_MOOD,
  MoodColors,
};

export default MoodsHelper;
